import React from 'react'
import { v4 as uuid } from 'uuid'
import clsx from 'clsx'

export const Badges = ({ badges, classes }) => {
  return !badges ? null : (
    <p className={classes['profile-card-badges-block']}>
      {badges.map((b) =>
        b.badge_name === 'Co-Founder' ? (
          <span
            className={clsx(
              classes[
                `profile-card-badge-${b.badge_name
                  .split(' ')
                  .join('-')
                  .toLowerCase()}`
              ],
              'badge',
              'badge-pill'
            )}
            key={uuid()}>
            <i className="fa fa-certificate" aria-hidden="true"></i>{' '}
            {b.badge_name}
          </span>
        ) : b.badge_name === 'Super Admin' ? (
          <span
            className={clsx(
              classes[
                `profile-card-badge-${b.badge_name
                  .split(' ')
                  .join('-')
                  .toLowerCase()}`
              ],
              'badge',
              'badge-pill'
            )}
            key={uuid()}>
            <i className="fa fa-bandcamp" aria-hidden="true"></i> {b.badge_name}
          </span>
        ) : b.badge_name === 'System Admin' ? (
          <span
            className={clsx(
              classes[
                `profile-card-badge-${b.badge_name
                  .split(' ')
                  .join('-')
                  .toLowerCase()}`
              ],
              'badge',
              'badge-pill',
              'badge-danger'
            )}
            key={uuid()}>
            <i className="fa fa-cog" aria-hidden="true"></i> {b.badge_name}
          </span>
        ) : b.badge_name === 'Developer' ? (
          <span
            className={clsx(
              classes[
                `profile-card-badge-${b.badge_name
                  .split(' ')
                  .join('-')
                  .toLowerCase()}`
              ],
              'badge',
              'badge-pill',
              'badge-dark'
            )}
            key={uuid()}>
            <i className="fa fa-connectdevelop" aria-hidden="true"></i>{' '}
            {b.badge_name}
          </span>
        ) : b.badge_name === 'Designer' ? (
          <span
            className={clsx(
              classes[
                `profile-card-badge-${b.badge_name
                  .split(' ')
                  .join('-')
                  .toLowerCase()}`
              ],
              'badge',
              'badge-pill',
              'badge-dark'
            )}
            key={uuid()}>
            <i className="fas fa-paint-brush" aria-hidden="true"></i>{' '}
            {b.badge_name}
          </span>
        ) : b.badge_name === 'Photographer' ? (
          <span
            className={clsx(
              classes[
                `profile-card-badge-${b.badge_name
                  .split(' ')
                  .join('-')
                  .toLowerCase()}`
              ],
              'badge',
              'badge-pill',
              'badge-dark'
            )}
            key={uuid()}>
            <i className="fa fa-camera" aria-hidden="true"></i> {b.badge_name}
          </span>
        ) : null
      )}
    </p>
  )
}

Badges.displayName = 'b'

export default Badges
